import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/AuthService';
import { k } from 'src/environments/properties';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  public active = 1;
  public userToken:string;

  constructor(
    private authService: AuthService
  ) { }

  ngOnInit() { 

    this.userToken =  localStorage.getItem(k.token);
  }


}
